import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Primary } from '../../../assets/Colors';
import TopicSelection from '../../../assets/adminIcons/task-list.png';
import AchivementSelection from '../../../assets/adminIcons/task-list.png';
import KPSSComp from '../../../assets/adminIcons/task.png';
import CMS from '../../../assets/adminIcons/folder.png';
import VideoSolution from '../../../assets/adminIcons/podcast.png';
import { getUserDetail, getUserStats } from '../../../api/UserDetail';
import { error } from '../../../components/Notification';
import SideBar from '../../../components/SideBar';
import { Components } from '../../../assets/Dimensions';
import { setSelectedItem } from '../../../redux/actions/sidebarAction';

const TeacherDashboard = ({ setSelectedItem }) => {
    const history = useHistory();
    const [stats, setStats] = useState({
        totalEntered: 0,
        totalApproved: 0,
        subTopicCount: 0,
        achievementCount: 0
    });
    const User = JSON.parse(localStorage.getItem('user'));
    useEffect(() => {
        setSelectedItem('');
        const fetchStats = async () => {
             if (User && User.Id) {
                try {
                    let res = await getUserStats({UserId: User.Id}, User.Token);
                    if (res.status === 200) {
                        setStats({
                            totalEntered: res.data.TotalEnteredQuestion || 0,
                            totalApproved: res.data.TotalApprovedQuestion || 0,
                            subTopicCount: res.data.SubCourseTopicSelectionCount || 0,
                            achievementCount: res.data.AchievementSelectionCount || 0
                        });
                    }
                } catch (e) {
                     console.error("Failed to fetch stats", e);
                }
             }
        };

        fetchStats();
    }, []);


    let menuItems = [];
    console.log("User",User);
    // Common items or default WorkList for regular teachers
    // if (User.Role !== 'TeacherEditors') {
    //      menuItems.push({ title: 'Work List', path: '/worklist', icon: MembersIcon });
    // }

    // Specific items for TeacherEditors
    if (User.Role === 'TeacherEditors') {
        menuItems = [
            ...menuItems,
            { title: 'Soru Video Çözüm Paneli', path: '/questionVideoSolution', icon: VideoSolution },
            { title: 'Sorulara Konu Ekleme', path: '/questionSubTopicSelectionCoursePage', icon: TopicSelection },
            { title: 'Sorulara Kazanım Ekleme', path: '/AchievementCourses', icon: AchivementSelection },
            { title: 'KPSS Soru Eşleştirme', path: '/KpssCompatibilityCourses', icon: KPSSComp },
            { title: 'CMS', path: '/NewTopicAndAchSelectionCoursePage', icon: CMS },
        ];
    }

    const statCards = [
        { label: 'Total Entered Questions', value: stats.totalEntered },
        { label: 'Total Approved Questions', value: stats.totalApproved },
        { label: 'SubTopic Selections', value: stats.subTopicCount },
        { label: 'Achievement Selections', value: stats.achievementCount },
    ];

    return (
        <div>
            <SideBar />
            <div style={{ 
                padding: 20, 
                marginLeft: Components.SideBarWidth + 15, 
                marginRight: 30,
                paddingTop: 20
            }}>
            <Typography variant="h4" style={{ color: Primary.TextColor, marginBottom: 20 }}>
                Teacher Dashboard {User.Role === 'TeacherEditors' ? '(Editor)' : ''}
            </Typography>

            {/* Statistics Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                Your Statistics
            </Typography>
            <Grid container spacing={3} style={{ marginBottom: 30 }}>
                {statCards.map((stat, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                         <Card style={{ height: '100%', backgroundColor: Primary.Background }}>
                            <CardContent style={{ textAlign: 'center' }}>
                                <Typography variant="h3" style={{ color: Primary.TopBar }}>
                                    {stat.value}
                                </Typography>
                                <Typography variant="subtitle1" style={{ color: Primary.TextColor }}>
                                    {stat.label}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Menu Section */}
            <Typography variant="h5" style={{ color: Primary.TextColor, marginBottom: 10 }}>
                Quick Access
            </Typography>
             <Grid container spacing={3}>
                {menuItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card 
                            style={{ cursor: 'pointer', height: '100%' }}
                            onClick={() => history.push(item.path)}
                        >
                            <CardContent style={{ textAlign: 'center' }}>
                                <img src={item.icon} alt={item.title} style={{ width: 50, height: 50, marginBottom: 10 }} />
                                <Typography variant="h6" component="h2">
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    User: state.userReducer.User
});

const mapDispatchToProps = (dispatch) => ({
    setSelectedItem: (item) => dispatch(setSelectedItem(item))
});

export default connect(mapStateToProps, mapDispatchToProps)(TeacherDashboard);
